import React from "react";
import { Modal as RBModal } from "react-bootstrap";

const Modal = ({ children, title, show, onHide, ...props  }) => {
  return (
    <RBModal centered show={show} onHide={onHide} {...props} >
      <RBModal.Header>
        <RBModal.Title>{title}</RBModal.Title>
        <span style={{ cursor: "pointer" }} onClick={onHide}>
          <p>Close x</p>
        </span>
      </RBModal.Header>
      <RBModal.Body>{children}</RBModal.Body>
    </RBModal>
  );
};

export default Modal;
